(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
  if (!customElements.get('bart-announcement-carousel')) {
    class BartAnnouncementCarousel extends HTMLElement {
      connectedCallback() {
        this.slides = [...this.querySelectorAll('.bart-announcement__item')];
        if (this.slides.length < 2) return;
        this.index = 0;
        this.paused = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.setAttribute('data-ready', '');
        this.show(0);
        this.onmouseenter = () => clearInterval(this.timer);
        this.onmouseleave = () => this.restart();
        this.onfocusin = () => clearInterval(this.timer);
        this.onfocusout = () => this.restart();
        this.onBlockSelect = event => {
          const index = this.slides.findIndex(slide => slide.contains(event.target));
          if (index >= 0) { this.show(index); this.paused = true; this.restart(); }
        };
        this.addEventListener('shopify:block:select', this.onBlockSelect);
        this.restart();
      }
      show(index) {
        this.index = (index + this.slides.length) % this.slides.length;
        this.slides.forEach((slide, i) => {
          const active = i === this.index;
          slide.toggleAttribute('data-active', active);
          slide.setAttribute('aria-hidden', String(!active));
          slide.inert = !active;
        });
      }
      restart() {
        clearInterval(this.timer);
        if (!this.paused && !this.matches(':hover') && !this.contains(document.activeElement)) {
          this.timer = setInterval(() => this.show(this.index + 1), 6000);
        }
      }
      disconnectedCallback() {
        clearInterval(this.timer);
        this.removeEventListener('shopify:block:select', this.onBlockSelect);
      }
    }
    customElements.define('bart-announcement-carousel', BartAnnouncementCarousel);
  }

  if (!customElements.get('bart-announcement-localization')) {
    class BartAnnouncementLocalization extends HTMLElement {
      connectedCallback() {
        const select = this.querySelector('select');
        const form = this.querySelector('form');

        if (select && form) {
          select.addEventListener('change', () => form.submit());
        }
      }
    }

    customElements.define('bart-announcement-localization', BartAnnouncementLocalization);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bart-brochure-popup"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bart-brochure-popup')) {
    customElements.define('bart-brochure-popup', class extends HTMLElement {
      connectedCallback() { this.initializer = setTimeout(() => this.initialize(), 0); }
      initialize() {
        if (!this.isConnected) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.dialog = this.querySelector('dialog');
        this.launcher = this.querySelector('.bart-brochure__launcher');
        this.form = this.querySelector('form');
        this.storageKey = 'bart-b2b-brochure-shown-v1';
        try {
          this.formUrl = new URL(this.form.action);
          if (this.formUrl.protocol !== 'https:' || !/(^|\.)sibforms\.com$/.test(this.formUrl.hostname)) return;
        } catch { return; }
        this.launcher.hidden = false;
        this.launcher.addEventListener('click', () => this.open(), options);
        this.querySelector('.bart-brochure__close').addEventListener('click', () => this.dialog.close(), options);
        this.dialog.addEventListener('click', (event) => {
          const box = this.dialog.getBoundingClientRect();
          if (event.target === this.dialog && (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom)) this.dialog.close();
        }, options);
        this.dialog.addEventListener('close', () => {
          this.focusTimer = setTimeout(() => { if (this.isConnected) this.launcher.focus({ preventScroll: true }); }, 0);
        }, options);
        this.form.addEventListener('submit', event => this.submit(event), options);
        document.addEventListener('visitorConsentCollected', () => this.trackBrochureRequest(), options);
        document.addEventListener('shopifyCustomerPrivacyApiLoaded', () => this.trackBrochureRequest(), options);
        if (window.Shopify?.designMode || this.dataset.auto !== 'true' || this.wasShownRecently()) return;
        this.timer = setTimeout(() => this.tryAutoOpen(), Math.max(5, Number(this.dataset.delay) || 10) * 1000);
      }
      wasShownRecently() {
        try { const last = Number(localStorage.getItem(this.storageKey)); return localStorage.getItem('bart-b2b-brochure-requested') === 'true' || (last > 0 && Date.now() - last < Math.max(1, Number(this.dataset.frequency) || 7) * 86400000); } catch { return false; }
      }
      tryAutoOpen() {
        if (!this.isConnected || this.wasShownRecently()) return;
        const modal = Array.from(document.querySelectorAll('dialog[open], [role="dialog"][aria-modal="true"]')).some(el => el.getClientRects().length > 0 && getComputedStyle(el).visibility !== 'hidden');
        const focused = document.activeElement;
        if (document.visibilityState !== 'visible' || modal || (focused && (focused.matches('input, textarea, select, iframe') || focused.isContentEditable))) { this.timer = setTimeout(() => this.tryAutoOpen(), 3000); return; }
        this.open();
      }
      open() {
        clearTimeout(this.timer);
        if (this.dialog.open) return;
        this.dialog.showModal();
        try { localStorage.setItem(this.storageKey, String(Date.now())); } catch {}
      }
      trackBrochureRequest() {
        clearTimeout(this.metaTimer);
        if (!this.isConnected || !this.brochureEventId || this.brochureEventSent || window.Shopify?.designMode) return;
        try {
          const privacy = window.Shopify?.customerPrivacy;
          const ready = privacy && typeof privacy.marketingAllowed === 'function' && typeof privacy.saleOfDataAllowed === 'function';
          if (ready && (!privacy.marketingAllowed() || !privacy.saleOfDataAllowed())) return;
          if (ready && typeof window.fbq === 'function') {
            this.brochureEventSent = true;
            window.fbq('trackSingleCustom', '610317541694272', 'BrochureRequest', {
              content_name: 'Zakelijke brochure',
              content_category: 'B2B',
              form_id: 'brochure_popup'
            }, { eventID: this.brochureEventId });
            return;
          }
        } catch {}
        this.metaChecks = (this.metaChecks || 0) + 1;
        if (this.metaChecks < 120) this.metaTimer = setTimeout(() => this.trackBrochureRequest(), 250);
      }
      async submit(event) {
        event.preventDefault();
        if (this.submitting || !this.form.reportValidity()) return;
        this.submitting = true;
        const button = this.form.querySelector('button[type=submit]');
        const label = button.textContent;
        const error = this.querySelector('.bart-brochure__error');
        error.hidden = true;
        button.disabled = true;
        button.textContent = button.dataset.pending;
        this.form.setAttribute('aria-busy', 'true');
        this.request = new AbortController();
        const timeout = setTimeout(() => this.request.abort(), 20000);
        try {
          const url = new URL(this.formUrl.href);
          url.searchParams.set('isAjax', '1');
          const response = await fetch(url.href, { method: 'POST', body: new FormData(this.form), credentials: 'omit', signal: this.request.signal });
          const result = await response.json();
          if (!response.ok || !result.success) throw new Error(result.message || error.dataset.default);
          this.form.reset();
          this.form.hidden = true;
          const success = this.querySelector('.bart-brochure__success');
          success.hidden = false;
          success.focus();
          try { localStorage.setItem('bart-b2b-brochure-requested', 'true'); } catch {}
          try {
            const id = window.crypto?.randomUUID ? window.crypto.randomUUID() : Date.now().toString(36) + '-' + Math.random().toString(36).slice(2);
            this.brochureEventId = this.brochureEventId || 'bart-brochure-' + id;
            this.trackBrochureRequest();
          } catch {}
        } catch (failure) {
          if (this.isConnected) { error.textContent = failure.name === 'AbortError' ? error.dataset.default : failure.message; error.hidden = false; }
        } finally {
          clearTimeout(timeout);
          this.submitting = false;
          button.disabled = false;
          button.textContent = label;
          this.form.removeAttribute('aria-busy');
        }
      }
      disconnectedCallback() { clearTimeout(this.initializer); clearTimeout(this.focusTimer); clearTimeout(this.timer); clearTimeout(this.metaTimer); this.controller?.abort(); this.request?.abort(); if (this.dialog?.open) this.dialog.close(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  if (!customElements.get('bart-localization-form')) {
    class BartLocalizationForm extends HTMLElement {
      constructor() {
        super();
        const select = this.querySelector('select');
        const form = this.querySelector('form');

        if (select && form) {
          select.addEventListener('change', () => form.submit());
        }
      }
    }

    customElements.define('bart-localization-form', BartLocalizationForm);
  }

  if (!customElements.get('sticky-header')) {
    class BartStickyHeader extends HTMLElement {
      connectedCallback() {
        this.headerSection = document.getElementById('shopify-section-header');
        if (this.headerSection) {
          this.headerSection.classList.add('shopify-section-header-sticky');
        }
      }

      disconnectedCallback() {
        if (this.headerSection) {
          this.headerSection.classList.remove('shopify-section-header-sticky');
        }
      }

      reveal() {
        if (this.headerSection) {
          this.headerSection.classList.add('shopify-section-header-sticky');
        }
      }
    }

    customElements.define('sticky-header', BartStickyHeader);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const sectionWrapper = this.closest('.shopify-section');

      if (sectionWrapper) {
        sectionWrapper.classList.add('product-recommendations-section');
      }

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');

              if (sectionWrapper) {
                sectionWrapper.classList.add('product-recommendations-section--loaded');
              }
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quotes"] && !Shopify.designMode) return;
  try {
    
(function($) {
    swipr = () => {
        if($('.quotes-slider').length) {          
            $(".quotes-slider").each(function(i) {
                let slides_per_view = $(this).attr('slidesperview');
                let pause_on_hover = $(this).attr('pauseonhover') ? true : false;
                let slide_delay = $(this).attr('slidedelay');
				let id = $(this).attr('slider-id');
                let swiper = new Swiper($(this)[0], {
                    loop: true,
                    slidesPerView: slides_per_view,
                    spaceBetween: 20,
                    autoplay: {
                        delay: slide_delay,
                    },
                  pagination: {
                    el: '#pagination-' + id + '-btn',
                    clickable: true
                  },
                  navigation: {
                    nextEl: '#next-' + id + '-btn',
                    prevEl: '#prev-' + id + '-btn'
                  },
              // Responsive breakpoints
                breakpoints: {
                  // when window width is >= 320px
                  320: {
                    slidesPerView: 1,
                    spaceBetween: 20
                  },
                  // when window width is >= 480px
                  480: {
                    slidesPerView: 1,
                    spaceBetween: 30
                  },
                  // when window width is >= 640px
                  640: {
                    slidesPerView: 2,
                    spaceBetween: 40
                  }
                }
                });
            });
        }
    };
     
    document.addEventListener("DOMContentLoaded", () => { swipr() }); 
})(jQuery);


  } catch(e) { console.error(e); }
})();
})();
